<h1 matDialogTitle>Header Details</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Customer Name</mat-label>
        <input #customerName matInput type="text" formControlName="customerName" maxlength="50" autocomplete="new-password">
        <mat-hint align="end">{{customerName.value.length}} / 50</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Company Tax Number</mat-label>
        <input #companyTaxNumber matInput type="text" formControlName="companyTaxNumber" maxlength="15" autocomplete="new-password">
        <mat-hint align="end">{{companyTaxNumber.value.length}} / 15</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Email</mat-label>
        <input #email matInput type="text" formControlName="email" maxlength="255" autocomplete="new-password">
        <mat-hint align="end">{{email.value.length}} / 255</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Building</mat-label>
        <input #shipToAddr1 matInput type="text" formControlName="shipToAddr1" maxlength="40" autocomplete="new-password">
        <mat-hint align="end">{{shipToAddr1.value.length}} / 40</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Str/Unit Nr</mat-label>
        <input #shipToAddr2 matInput type="text" formControlName="shipToAddr2" maxlength="40" autocomplete="new-password">
        <mat-hint align="end">{{shipToAddr2.value.length}} / 40</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Street Name</mat-label>
        <input #shipToAddr3 matInput type="text" formControlName="shipToAddr3" maxlength="40" autocomplete="new-password">
        <mat-hint align="end">{{shipToAddr3.value.length}} / 40</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Suburb / City</mat-label>
        <input #shipToAddr4 matInput type="text" formControlName="shipToAddr4" maxlength="40" autocomplete="new-password">
        <mat-hint align="end">{{shipToAddr4.value.length}} / 40</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Province</mat-label>
        <input #shipToAddr5 matInput type="text" formControlName="shipToAddr5" maxlength="40" autocomplete="new-password">
        <mat-hint align="end">{{shipToAddr5.value.length}} / 40</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="40" width="100%">
        <mat-label>Postal Code</mat-label>
        <input #shipPostalCode matInput type="text" formControlName="shipPostalCode" maxlength="10" autocomplete="new-password">
        <mat-hint align="end">{{shipPostalCode.value.length}} / 10</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Latitude</mat-label>
        <input #shipPostalCode matInput type="number" formControlName="shipToGpsLat"
          autocomplete="new-password">
      </mat-form-field>

      <mat-form-field fxFlex="30" width="100%">
        <mat-label>Longitude</mat-label>
        <input #shipPostalCode matInput type="number" formControlName="shipToGpsLong"
          autocomplete="new-password">
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Save</button>
</mat-dialog-actions>
